import { ref, onValue, update } from "firebase/database";
import { db } from "./firebase";

/* =================================================
   🔔 HOME ICON – UNREAD COUNT (FIXED)
================================================= */
export function listenAdminMessageCount(uid, setUnreadCount) {
  if (!uid) return;

  const msgRef = ref(db, "admin_messages");
  const readRef = ref(db, `admin_message_reads/${uid}`);
  const userRef = ref(db, `users/${uid}/joined_at`);

  let messages = {};
  let read = {};
  let joinedAt = 0;

  // ✅ Get joined time
  onValue(userRef, snap => {
    if (snap.exists()) {
      joinedAt = snap.val();
    } else {
      joinedAt = Date.now();
    }
    calculate();
  });

  onValue(msgRef, snap => {
    messages = snap.val() || {};
    calculate();
  });

  onValue(readRef, snap => {
    read = snap.val() || {};
    calculate();
  });

  function calculate() {
    const count = Object.keys(messages).filter(msgId => {
      const msg = messages[msgId];
      if (!msg || !msg.timestamp) return false;

      const isActive = msg.active === true;
      const isUnread = !read[msgId];
      const isNew = msg.timestamp > joinedAt; // ⭐ IMPORTANT

      return isActive && isUnread && isNew;
    }).length;

    setUnreadCount(count);
  }
}

/* =================================================
   📩 USER MESSAGES – ONLY NEW + UNREAD (FIXED)
================================================= */
export function listenAdminMessages(uid, setMessages) {
  if (!uid) return;

  const msgRef = ref(db, "admin_messages");
  const readRef = ref(db, `admin_message_reads/${uid}`);
  const userRef = ref(db, `users/${uid}/joined_at`);

  let messages = {};
  let read = {};
  let joinedAt = 0;

  // ✅ Get joined time
  onValue(userRef, snap => {
    if (snap.exists()) {
      joinedAt = snap.val();
    } else {
      joinedAt = Date.now();
    }
    updateUI();
  });

  onValue(msgRef, snap => {
    messages = snap.val() || {};
    updateUI();
  });

  onValue(readRef, snap => {
    read = snap.val() || {};
    updateUI();
  });

  function updateUI() {
    const list = Object.entries(messages)
      .filter(([id, msg]) => {
        if (!msg || !msg.timestamp) return false;

        const isActive = msg.active === true;
        const isUnread = !read[id];
        const isNew = msg.timestamp > joinedAt; // ⭐ IMPORTANT

        return isActive && isUnread && isNew;
      })
      .map(([id, msg]) => ({
        ...msg,
        messageId: id,
      }))
      .sort((a, b) => b.timestamp - a.timestamp);

    setMessages(list);
  }
}

/* =================================================
   ✅ MARK AS READ
================================================= */
export function markAdminMessagesRead(uid, messages) {
  if (!uid || messages.length === 0) return;

  const updates = {};

  messages.forEach(msg => {
    updates[`admin_message_reads/${uid}/${msg.messageId}`] = true;
  });

  return update(ref(db), updates);
}